import { useEffect } from 'react';
import { DFPManager } from 'react-dfp';
import { IDFP } from 'api/types/searchPageApiTypes';
import {
  getTargetingArguments,
  refreshAdSlots,
} from 'components/Toolkit/DFP/DFP';

function useDFP(settings: IDFP) {
  useEffect(() => {
    DFPManager.setTargetingArguments({
      ...getTargetingArguments(),
      ...settings,
    });
  }, []);

  function refresh() {
    DFPManager.setTargetingArguments({
      ...getTargetingArguments(),
      ...settings,
    });
    refreshAdSlots();
  }

  return {
    refresh,
  };
}

export { useDFP };
